/**
 * Little Legs Locale Preservation
 * Ensures locale is maintained during cart updates
 */
(function() {
  'use strict';
  
  // Get current locale
  const currentLocale = window.Shopify?.locale || document.documentElement.lang || 'en';
  
  /**
   * Add locale parameter to URL
   */
  function addLocaleToUrl(url) {
    if (!url) return url;
    
    // Don't add locale if it's already English
    if (currentLocale === 'en') return url;
    
    // Parse URL
    const urlObj = new URL(url, window.location.origin);
    
    // Add locale parameter if not present
    if (!urlObj.searchParams.has('locale')) {
      urlObj.searchParams.set('locale', currentLocale);
    }
    
    return urlObj.toString();
  }
  
  /**
   * Override native fetch to automatically include locale
   */
  const originalFetch = window.fetch;
  window.fetch = function(url, options = {}) {
    // Only modify cart-related requests
    if (typeof url === 'string' && (
      url.includes('/cart') || 
      url.includes('routes.cart') ||
      url.includes('change.js') ||
      url.includes('add.js') ||
      url.includes('update.js')
    )) {
      const originalUrl = url;
      url = addLocaleToUrl(url);
      
      if (originalUrl !== url) {
        console.log('[Locale] Preserved locale in fetch:', url);
      }
    }
    
    return originalFetch(url, options);
  };
  
  /**
   * Intercept Shopify cart updates
   */
  if (window.Shopify && window.Shopify.routes) {
    // Store original routes
    const originalRoutes = { ...window.Shopify.routes };
    
    // Override routes with locale-aware versions
    Object.keys(originalRoutes).forEach(key => {
      if (key.includes('cart')) {
        Object.defineProperty(window.Shopify.routes, key, {
          get: function() {
            return addLocaleToUrl(originalRoutes[key]);
          }
        });
      }
    });
  }
  
  /**
   * Intercept route variables
   */
  if (typeof routes !== 'undefined') {
    const originalCartRoutes = { ...routes };
    
    ['cart_url', 'cart_add_url', 'cart_change_url', 'cart_update_url'].forEach(route => {
      if (originalCartRoutes[route]) {
        Object.defineProperty(routes, route, {
          get: function() {
            return addLocaleToUrl(originalCartRoutes[route]);
          }
        });
      }
    });
  }
  
  /**
   * Observer to handle dynamically added forms
   */
  function updateFormActions() {
    document.querySelectorAll('form[action*="/cart"]').forEach(form => {
      const action = form.getAttribute('action');
      if (action && !action.includes('locale=')) {
        form.setAttribute('action', addLocaleToUrl(action));
      }
    });
  }
  
  // Update forms on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFormActions);
  } else {
    updateFormActions();
  }
  
  // Watch for dynamic content
  const observer = new MutationObserver(updateFormActions);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Export utility
  window.LocalePreservation = {
    currentLocale: currentLocale,
    addLocaleToUrl: addLocaleToUrl
  };
  
  console.log('Locale preservation active:', currentLocale);
  
})();
